import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseRefetchInfiniteQuery = (wrapperOptions) => {
    const useRefetchInfiniteQuery = () => {
        const client = useQueryClient();
        const queryKey = getQueryBaseKey(wrapperOptions, 'infiniteQuery');
        return () => client.refetchQueries({ queryKey });
    };
    return useRefetchInfiniteQuery;
};
